export const RUN_MODE_CONST = {
  DEV: 'development',
  PROD: 'production',
}
